import { OfferFilters } from '@/interfaces/filters/offerFilters';
import { Offer } from '@/interfaces/offer';
import { OfferResource, offerResource } from '@/resources/offer.resource';
import { EntityModule } from '../entity.module';

/**
 * Moduł wniosków profilu
 *
 * @export
 * @class OfferModule
 * @extends {EntityModule<Offer, OfferResource>}
 */
export class ProfileOfferModule extends EntityModule<Offer, OfferResource> {
  constructor() {
    super(offerResource);

    const superList = this.actions.list;

    this.actions = {
      ...this.actions,
      /**
       * Pobiera listę encji
       *
       * @param context context
       * @param filters filtry listy
       */
      list: (context: any, filters: OfferFilters): Promise<void> => {
        filters.profileId = context.rootState.profile.id;
        return superList(context, filters);
      }
    };
  }
}

export default new ProfileOfferModule();
